var _defs, _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatasetExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 12,
    cy: 12,
    r: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 11.935,
    cy: 2.232,
    r: 22.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fafafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8cdd1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 3.515,
    x2: 20.485,
    y1: 3.515,
    y2: 20.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#889097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64717c"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffa000"
    },
    d: "M40 12H22l-4-4H8c-2.2 0-4 1.8-4 4v8h40v-4c0-2.2-1.8-4-4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffca28"
    },
    d: "M40 12H8c-2.2 0-4 1.8-4 4v20c0 2.2 1.8 4 4 4h32c2.2 0 4-1.8 4-4V16c0-2.2-1.8-4-4-4Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18 18) scale(1.16667)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#a)"
    },
    fill: "url(#a)",
    r: 12,
    cy: 12,
    cx: 12
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#b)"
    },
    fill: "url(#b)",
    r: 11,
    cy: 12,
    cx: 12
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#c)"
    },
    fill: "url(#c)",
    r: 10,
    cy: 12,
    cx: 12
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5a.5.5 0 0 1-.354-.853l5.091-5.091a.5.5 0 0 1 .707.707l-5.091 5.091A.498.498 0 0 1 12 12.5Z",
    fill: "#45494d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.999 12.75a.741.741 0 0 1-.334-.079l-6-3a.75.75 0 0 1 .67-1.342l6 3a.75.75 0 0 1-.336 1.421z",
    fill: "#45494d"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#1e2021",
    r: 1.5,
    cy: 12,
    cx: 12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasetExpired);
export default __webpack_public_path__ + "static/media/datasetExpired.67bd00a3a383516aab1a94c94b4473ff.svg";
export { ForwardRef as ReactComponent };